const BASEURL = "https://msinvs.com/backend/";

const INVS = BASEURL + "invs/";

export const getInvs = async () => {
  const res = await fetch(INVS + "getInvs.php");
  return await res.json();
};
export const getInv = async (id) => {
  const res = await fetch(INVS + "getInv.php?id=" + id);
  return await res.json();
};
export const getLastInvs = async () => {
  const res = await fetch(INVS + "getLastInvs.php");
  return await res.json();
};

export const getFullInvs = async () => {
  const res = await fetch(INVS + "getFullInvs.php");
  return await res.json();
};

export const getClosedInvs = async () => {
  const res = await fetch(INVS + "getClosedInvs.php");
  return await res.json();
};
export const getNextInvs = async () => {
  const res = await fetch(INVS + "getNextInvs.php");
  return await res.json();
};

//POR LONGITUD
export const getShortInvs = async () => {
  const res = await fetch(INVS + "getShortInvs.php");
  return await res.json();
};
export const getMediumInvs = async () => {
  const res = await fetch(INVS + "getMediumInvs.php");
  return await res.json();
};
export const getLongInvs = async () => {
  const res = await fetch(INVS + "getLongInvs.php");
  return await res.json();
};

//POR USUARIO
export const getOpenInvsByUser = async (id) => {
  const res = await fetch(INVS + "getOpenInvsByUser.php?id=" + id);
  return await res.json();
};
export const getClosedInvsByUser = async (id) => {
  const res = await fetch(INVS + "getClosedInvsByUser.php?id=" + id);
  return await res.json();
};
export const getEndedInvsByUser = async (id) => {
  const res = await fetch(INVS + "getEndedInvsByUser.php?id=" + id);
  return await res.json();
};

//IMAGES
export const getInvImages = async (id) => {
  const res = await fetch(INVS + "getInvImages.php?id=" + id);
  return await res.json();
};

export const getLegal = async (investment_id, user_id) => {
  const res = await fetch(
    INVS + "getLegal.php?invId=" + investment_id + "&userId=" + user_id
  );
  return await res.json();
};

const USERS = BASEURL + "users/";

/* ESTE DELETE BORRA DEL TODO
export const deleteUser = async (id) => {
    await fetch(USERS+"/"+id, {
      method: "DELETE",
    });
  };
*/
export const getAllUsersEmail = async () => {
  const res = await fetch(USERS + "getAllUsersEmail.php");
  return await res.json();
};

export const getUserByEmail = async (email) => {
  const res = await fetch(USERS + "getUserByEmail.php?email=" + email);
  return await res.json();
};

export const getUserById = async (id) => {
  const res = await fetch(USERS + "getUserById.php?id=" + id);
  return await res.json();
};

export const newUser = async (registerUser) => {
  const res = await fetch(USERS + "newUser.php", {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(registerUser),
  });
  return await res.json();
};

export const newUserLogin = async (id) => {
  const res = await fetch(USERS + "newUserLogin.php?id=" + id, {
    method: "POST",
  });
  return await res.json();
};

export const updateUserData = async (id, moneyValue) => {
  const res = await fetch(USERS + "updateUserData.php?id=" + id, {
    method: "PUT",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(moneyValue),
  });
  return await res.json();
};

export const getUserAndCode = async (id) => {
  const res = await fetch(USERS + "getUserAndCode.php?id=" + id);
  return await res.json();
};

const MONEY = BASEURL + "money/";

export const newInvestMoney = async (addInvMoney) => {
  const res = await fetch(MONEY + "newInvestMoney.php", {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(addInvMoney),
  });
  return await res.json();
};

export const getMoneyByInvestment = async (inv_id) => {
  const res = await fetch(MONEY + "getMoneyByInvestment.php?id=" + inv_id);
  return await res.json();
};

export const getMoneyInvestedGeneral = async () => {
  const res = await fetch(MONEY + "getMoneyInvestedGeneral.php");
  return await res.json();
};

export const getMoneyBenefit = async (inv_id, user_id) => {
  const res = await fetch(
    MONEY + "getMoneyBenefit.php?invId=" + inv_id + "&userId=" + user_id
  );
  return await res.json();
};

export const getMoneyByInvestmentAndUser = async (user_id) => {
  const res = await fetch(
    MONEY + "getMoneyByInvestmentAndUser.php?id=" + user_id
  );
  return await res.json();
};

export const getCountableBalance = async (id) => {
  const res = await fetch(MONEY + "getCountableBalance.php?id=" + id);
  return await res.json();
};

export const getIfInvested = async (id, user_id) => {
  const res = await fetch(
    MONEY + "getIfInvested.php?invId=" + id + "&userId=" + user_id
  );
  return await res.json();
};

const MAIL = BASEURL + "mailer/";

export const sendMail = async (mail) => {
  const res = await fetch(MAIL + "sendMail.php", {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(mail),
  });
  return await res.json();
};

export const sendMailUserInvest = async (mail) => {
  const res = await fetch(MAIL + "sendMailUserInvest.php", {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(mail),
  });
  return await res.json();
};

const VOTE = BASEURL + "votes/";

export const getDownvotes = async (investment_id) => {
  const res = await fetch(VOTE + "getDownvotes.php?id=" + investment_id);
  return await res.json();
};

export const getUpvotes = async (investment_id) => {
  const res = await fetch(VOTE + "getUpvotes.php?id=" + investment_id);
  return await res.json();
};

export const getUserVote = async (investment_id, user_id) => {
  const res = await fetch(
    VOTE + "getUserVote.php?invId=" + investment_id + "&userId=" + user_id
  );
  return await res.json();
};

export const getAllVotes = async () => {
  const res = await fetch(VOTE + "getAllVotes.php");
  return await res.json();
};

export const newVote = async (voteInfo) => {
  const res = await fetch(VOTE + "newVote.php", {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(voteInfo),
  });
  return await res.json();
};

export const updateVote = async (id, voteInfo) => {
  const res = await fetch(VOTE + "updateVote.php?id=" + id, {
    method: "PUT",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(voteInfo),
  });
  return await res.json();
};
